import Vue from 'vue'
import VueRouter from 'vue-router'
import PC from '../views/PC.vue'
import Mobile from '../views/Mobile.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/pc',
    name: 'PC',
    component: PC
  },
  {
    path: '/mobile',
    name: 'Mobile',
    component: Mobile
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 设备判断函数
const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

// 全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/') {
    // 如果是访问根路径，根据设备类型重定向
    if (isMobile()) {
      next('/mobile')
    } else {
      next('/pc')
    }
  } else {
    next()
  }
})

export default router 